import classNames from 'classnames'

import { ShadowBox } from 'components/ShadowBox'
import { UpdateTag } from 'components/tag/UpdateTag'
import { PropsWithChildren, useState } from 'react'
import { UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { FormValues } from 'utils/type'
import { useScriptStore } from 'store/useScriptStore'
import { isMobile } from 'react-device-detect'

interface ScriptInputModeProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
}

export const ScriptInputModeToggle = ({
  watch,
  setValue,
}: PropsWithChildren<ScriptInputModeProps>) => {
  const {
    promptName,
    toneName,
    toggleModal,
    isAIGenerated,
    setIsAIGenerated,
    toggleAIGenerated,
  } = useScriptStore()

  const handleAiGenerateScript = () => {
    const newProducts = watch('products').map((el) => {
      el.userScript = ''

      return el
    })

    setValue('products', newProducts)
  }

  return (
    <ShadowBox className="md:w-[816px] w-[375px] ">
      <div className="flex gap-2 items-start justify-center mt-10 md:mt-0">
        <p className="text-[24px] font-bold">대본 생성 방법 선택</p>
        <UpdateTag />
      </div>
      <div
        className={classNames('flex gap-4 mt-4 cursor-pointer', {
          'flex-col ': isMobile,
        })}
      >
        <div
          className={classNames(
            ' rounded-[20px] min-h-[215px] border-[2px] flex flex-col gap-4 p-4',
            {
              'bg-[#F6F8FB]': isAIGenerated,
              'bg-[#E9F8F9] outline outline-[2px] outline-[#00B7B9]':
                !isAIGenerated,
              'w-[50%]': !isMobile,
              'w-full': isMobile,
            }
          )}
          onClick={() => setIsAIGenerated(false)}
        >
          <label className="relative flex items-center cursor-pointer gap-2 ">
            <div
              className={`w-[20px] h-[20px] rounded-full border-2 bg-main flex items-center justify-center ${
                !isAIGenerated ? 'bg-white border-main' : 'bg-white'
              }`}
            >
              {!isAIGenerated && (
                <div className="w-3 h-3 bg-main rounded-full"></div>
              )}
            </div>
            <span className="font-bold">
              ✍️ AI로 생성하고, 내가 직접 편집하기
            </span>
          </label>
          <p>
            AI가 생성한 400자 내외의 상품 리뷰 대본을 직접 확인하고 수정할 수
            있어요. <br />
            내가 직접 편집한 대본으로 스타일에 맞게 완성하고 싶을 때 선택하세요!
          </p>
        </div>
        <div
          className={classNames(
            'rounded-[20px] min-h-[215px] border-[2px] flex flex-col p-4 gap-4  cursor-pointer',
            {
              'bg-[#F6F8FB]': !isAIGenerated,
              'bg-[#E9F8F9] outline outline-[2px] outline-[#00B7B9]':
                isAIGenerated,
              'w-[50%]': !isMobile,
              'w-full': isMobile,
            }
          )}
          onClick={() => {
            setIsAIGenerated(true)
            handleAiGenerateScript()
          }}
        >
          <label className="relative flex items-center cursor-pointer gap-2">
            <div
              className={`w-[20px] h-[20px] rounded-full border-2 bg-main flex items-center justify-center ${
                isAIGenerated ? 'bg-white border-main' : 'bg-white'
              }`}
            >
              {isAIGenerated && (
                <div className="w-3 h-3 bg-main rounded-full"></div>
              )}
            </div>
            <span className="font-bold">🤖 AI에게 모두 맡기기</span>
          </label>
          <p>
            컨셉과 말투만 선택 해놓으면, AI가 대본을 자동으로 작성하고, 편집
            없이 바로 영상에 적용합니다.
            <br /> 빠르게 제작하고 싶을 때 추천해요!
          </p>

          <div className="w-full  min-h-[61px] rounded-[10px] bg-white p-2 flex items-center justify-between font-bold ">
            <div className="w-full flex flex-col  gap-2 justify-center">
              <p className="flex items-center text-[14px] gap-2 flex-shrink-0 ">
                <span className="bg-[#D9DEE8] px-1 py-[2px] text-[#8F929B] rounded-[4px] flex-shrink-0">
                  컨셉
                </span>
                <span
                  className={classNames('', {
                    'text-[#8F929B] ': !isAIGenerated,
                    'text-black': isAIGenerated,
                  })}
                >
                  {promptName}
                </span>
              </p>
              <p className="flex items-center text-[14px] gap-2">
                <span className="bg-[#D9DEE8] px-1 py-[2px] text-[#8F929B] rounded-[4px] flex-shrink-0">
                  말투
                </span>
                <span
                  className={classNames('', {
                    'text-[#8F929B] ': !isAIGenerated,
                    'text-black': isAIGenerated,
                  })}
                >
                  {toneName}
                </span>
              </p>{' '}
            </div>
            <button
              className={classNames(
                'px-2 py-[6px] rounded-[4px] text-[14px] shrink-0 disabled:bg-[#D9DEE8]',
                {
                  'text-[white] bg-[#D9DEE8] ': !isAIGenerated,
                  'text-[white] bg-[#2E343D]': isAIGenerated,
                }
              )}
              onClick={() => {
                toggleModal()
              }}
              type="button"
              disabled={!isAIGenerated}
            >
              선택 {'>'}
            </button>
          </div>
        </div>
      </div>
    </ShadowBox>
  )
}
